// extracted by mini-css-extract-plugin
module.exports = {"label_spec":"secondaryDressing_label_spec__3Kk6d","warning":"secondaryDressing_warning__2f_S6"};